import styles from './spinner.module.css';

const Spinner = () => (
  <div className={styles.spinnerWrap}>
    <div className={styles.spinner} aria-label="loading..." />
  </div>
);
export default Spinner;
